import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import dayjs from 'dayjs';
import moment from 'moment';
import { memo } from 'react';

const DaysCalendarHeaderFirst = (props: any) => {
  const dayOfWeek = (date: any) => {
    const day = moment(new Date(date));
    return day.format('dd')
  }

  return props.daysCal.map((day: any, index: number) => (
    <th
      id={day['day']}
      className={`day_${index}`}
      key={day['day']}
      align='center'
      colSpan={day['colspan']}

    >
      <Stack direction={'row'}>
        {!props.dateSelect(day['day']) ? (
          <Box sx={{ mx: 'auto' }}>
            <Typography
              sx={{
                fontWeight: '400',
                lineHeight: '10px',
                fontSize: '10px',
              }}
              component='pre'
            >
              {dayOfWeek(dayjs(day['day']))}
            </Typography>
            <Typography
              sx={{
                fontWeight: '500',
                lineHeight: '21.6px',
                fontSize: '23px',
              }}
              component='pre'
            >
              {dayjs(day['day']).format('D')}
            </Typography>
          </Box>
        ) : (
          <Box
            sx={{
              bgcolor: '#23B7E5',
              borderRadius: '100px',
              width: '44px',
              height: '44px',
              mx: 'auto',
              pt: '4px',
            }}
          >
            <Typography
              sx={{
                fontWeight: '400',
                lineHeight: '10px',
                fontSize: '10px',
                color: '#FFFFFF',
              }}
              component='pre'
            >
              {dayOfWeek(dayjs(day['day']))}
            </Typography>
            <Typography
              sx={{
                fontWeight: '500',
                lineHeight: '21.6px',
                fontSize: '24px',
                color: '#FFFFFF',
              }}
              component='pre'
            >
              {dayjs(day['day']).format('D')}
            </Typography>
          </Box>
        )}
        {!props.offPrint && (
          <IconButton
            onClick={props.handlePrintDate(day['day'])}
            title='Print date'
          >
            <img
              src='/images/ic-print.svg'
              style={{ width: '24px', height: '24px' }}
              alt='icon'
            />
          </IconButton>
        )}
      </Stack>
    </th>
  ))
};

export default memo(DaysCalendarHeaderFirst);
